// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cnt-area[data-v-4ff421c0]{margin-top:40px}.list-table[data-v-4ff421c0]{border:1px solid #ebeef5;padding:0}.ellipse[data-v-4ff421c0]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.v-modal[data-v-4ff421c0]{z-index:2000!important}", ""]);
// Exports
module.exports = exports;
